export default {
  dropHint: "Drop image anywhere",
  dragDropHint: "Drag and drop image in OR click to upload",
  dropzoneHint: {
    pointer: "Drag and drop image in OR click to upload",
    touch: "Tap to choose a photo"
  },
  reuploadHint: "Original image is ready. Click to re-upload",
  reuploadAction: "Re-upload",
  originalReadyPreview: "Original image uploaded",
  originalPreviewAlt: "Uploaded original image preview",
  originalPreviewFallback: "Original image preview unavailable",
  limitText: "less than 30MB",
  compressing: {
    title: "Compressing image",
    message: "The image is large, compressing now, please wait…",
  },
  loginResume: {
    loadingTitle: "Restoring your analysis",
    loadingMessage: "Restoring your previous analysis session, please wait…",
    failedTitle: "Couldn't restore your analysis",
    failedMessage: "We couldn't find your previous unfinished session. Please upload the photo again.",
    missingImageMessage: "The local image cache is no longer available. Please upload the photo again.",
  },
  step: {
    uploadOriginal: "Upload your photo",
    selectPreset: "Select reference style",
  },
  preset: {
    title: "Step 2: Select a reference style",
    description: "Pick one preset style as the target look for this task.",
    empty:
      "Preset style library is temporarily unavailable. Please try again later.",
    reload: "Reload Preset Library",
    imageLoadError: "Asset load failed",
    categoryTitle: "Style Categories",
    categoryAll: "All",
    categoryFeatured: "Featured",
    featuredBadge: "Featured",
    lightboxAriaLabel: "Zoom in to view reference style",
  },
  action: {
    startAnalysis: "Start Analysis",
    skipPreset: "Skip preset and continue in compatibility mode",
  },
  error: {
    invalidType: {
      title: "Invalid File Type",
      message: "Please upload an image file",
    },
    tooLarge: {
      title: "File Too Large",
      message: "Image size should not exceed 30MB",
    },
    folderDropped: {
      title: "Folders Not Supported",
      message: "Please drag a single image file, not a folder.",
    },
    nonFileDropped: {
      title: "Unsupported Content",
      message: "Please drag an image file. Links or text are not accepted.",
    },
    emptyFile: {
      title: "No File Received",
      message:
        "We didn't receive a readable image file. Please choose an image again.",
    },
    readFailed: {
      title: "Image Read Failed",
      message:
        "We couldn't read this image. Please choose it again from your device's gallery or file manager, or try another image.",
    },
    presetRequired: {
      title: "Select a reference style",
      message: "Please choose one reference style before starting analysis.",
    },
    invalidPreset: {
      title: "Reference style unavailable",
      message:
        "The selected reference style is invalid. Please choose another one.",
    },
    historyQuotaExceeded: {
      title: "History quota reached",
      message:
        "Your history quota is currently full. Clear older history items or try again later.",
    },
    paymentPending: {
      title: "Payment is still being confirmed",
      message:
        "We are still synchronizing your payment result. Please try starting the analysis again shortly.",
    },
    relationSaveFailed: {
      title: "Failed to initialize analysis task",
      message: "The upload relation could not be saved. Please try again.",
    },
  },
};
